import React from 'react';
import { ScarcityBanner } from '../components/ScarcityBanner';
import { PriceAlert } from '../components/PriceAlert';
import { HeroLP1 } from '../components/HeroLP1';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP3() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1133">
      <ScarcityBanner data-id="element-1134" />
      <PriceAlert data-id="element-1135" />
      <HeroLP1 data-id="element-1136" />
      <Testimonial data-id="element-1137" />
      <ProblemSolution data-id="element-1138" />
      <ValueStack data-id="element-1139" />
      <ModuleBreakdown data-id="element-1140" />
      <Guarantee data-id="element-1141" />
      <PricingSection data-id="element-1142" />
      <Footer data-id="element-1143" />
      <RecentPurchaseToast data-id="element-1144" />
    </div>;
}